export const BAD_REQUEST              = 400;
export const UNAUTHENTICATED          = 401;
export const FORBIDDEN                = 403;
export const VALIDATION_SERVER_ERROR  = 422;
export const LOGIN_2FA_REQUIRED       = 496;
export const ACCESS_TOKEN_EXPIRED     = 497;
export const REFRESH_TOKEN_EXPIRED    = 498;
export const INTERNAL_SERVER_ERROR    = 500;
